import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (roughly 600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
    window.location.href = 'https://www.mujerdigital2.com/cart/PLACEHOLDER:1';
  };
  return <AnimatePresence data-id="element-178">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 lg:hidden" data-id="element-179">
          <div className="bg-[#0A0A23]/95 backdrop-blur-md border-t border-[#E07AF0]/20 px-4 py-3 flex items-center justify-between gap-3" data-id="element-180">
            <div className="flex flex-col" data-id="element-181">
              <span className="text-white font-bold text-sm" data-id="element-182">
                Vínculos de Hierro
              </span>
              <span className="text-[#E07AF0] font-bold text-lg" data-id="element-183">
                $9.900{' '}
                <span className="text-[#9090B0] text-xs font-normal" data-id="element-184">ARS</span>
              </span>
            </div>
            <button onClick={handleClick} className="bg-[#E07AF0] hover:bg-[#d066e0] text-[#0A0A23] font-bold text-sm px-5 py-3 rounded-full flex items-center gap-2 shadow-[0_0_20px_rgba(224,122,240,0.3)] transition-all duration-300 whitespace-nowrap" data-id="element-185">
              COMPRAR AHORA
              <ArrowRight className="w-4 h-4" data-id="element-186" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}